module.exports = __webpack_public_path__ + "img/zt-wdj.2dc8eadd.png";